export function Comparison(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/library-tags/comparison`;
}

export function ComparisonExport(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/library-tags/comparison/export`;
}

export function ComparisonPlayers(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/library-tags/comparison/players`;
}

export function ComparisonPlayersExport(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/library-tags/comparison/players/export`;
}

export function Create(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/library-tags`;
}

export function Delete(organizationID: number, libraryTagID: string): string {
	return `/v1/organizations/${organizationID}/library-tags/${libraryTagID}`;
}

export function Index(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/library-tags`;
}

export function LegacyMigrationExecute(organizationID: number): string {
	return `/v1/organizations/${organizationID}/library-tags/legacy-migration`;
}

export function LegacyMigrationPreview(organizationID: number): string {
	return `/v1/organizations/${organizationID}/library-tags/legacy-migration`;
}

export function Merge(organizationID: number): string {
	return `/v1/organizations/${organizationID}/library-tags/merge`;
}

export function Reorder(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/library-tags/sort-order`;
}

export function TrainingSummary(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/library-tags/training-summary`;
}

export function TrainingSummaryExport(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/library-tags/training-summary/export`;
}

export function Update(organizationID: number, libraryTagID: string): string {
	return `/v1/organizations/${organizationID}/library-tags/${libraryTagID}`;
}

